import { toast } from "react-toastify";
import { call, put } from "redux-saga/effects";
import { actionTypes } from "../../Utils/Constants";
import { encrypt } from "../../Utils/Crypto";
import { httpUnAuth } from "../../Utils/http";

export function* login(action) {
  try {
    const response = yield httpUnAuth.post("v1/signin/otp", action.params);
    const { token, user } = response.data;

    yield call([localStorage, "setItem"], "tok", encrypt(token));
    yield call(
      [localStorage, "setItem"],
      "un",
      encrypt(action.params.username)
    );
    yield call([localStorage, "setItem"], "_us", encrypt(JSON.stringify(user)));

    yield put({
      type: actionTypes.LOGIN_SUCCESS,
      token,
      username: action.params.username,
      user,
    });
  } catch (err) {
    toast.error("Please enter valid OTP.");
    yield put({ type: actionTypes.LOGIN_FAILED });
  }
}

export function* logout() {
  yield call([localStorage, "removeItem"], "tok");
  yield call([localStorage, "removeItem"], "un");
  yield call([localStorage, "removeItem"], "_us");

  yield put({
    type: actionTypes.LOGOUT_SUCCESS,
  });
}
